// Create blank listingpage component
import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Button, MobileStepper } from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views-react-18-fix';
import { autoPlay } from 'react-swipeable-views-utils-react-18-fix';
import "./ListingPage.css";
import Cookies from 'js-cookie';
import api from "../../apiConfig";
import {useParams} from "react-router-dom";
import { useNavigate } from 'react-router-dom';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const ListingPage = () => {
  const { id } = useParams();
  const theme = useTheme();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [propertyData, setPropertyData] = useState(null);
    const [images, setImages] = useState([]);

  const [isLoggedIn, setIsLoggedIn] = useState(false); // Existing line

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const [soldHistory, setSoldHistory] = useState([]);

  useEffect(() => {

    const accessToken = Cookies.get('access_token');
    const refreshToken = Cookies.get('refresh_token');
    if (accessToken && refreshToken) {
        setIsLoggedIn(true);
    }
    const fetchData = async () => {
        const response = await api.get(`/vow_homes/api/${id}`);
        const data = await response.data;
        setPropertyData(data);
    };

    fetchData();

  }, [id]);

  useEffect(() => {
    if (propertyData) {
      document.title = `MLS® Number: ${propertyData["Ml_num"]}`;
    }
  }, [propertyData]);

  useEffect(() => {
    // Mock function to simulate fetching image URLs from a directory
    const fetchImages = async () => {
      try {
        const response = await api.get(`/vow_homes/api/get_images/${id}`); // Adjusted to your actual API endpoint
        if (response && response.data) {
          // Assuming response.data is an array of image filenames
          // Construct URLs for each image
          const imageUrls = response.data.map(fileName =>
            `https://arshinmar.com/vow_homes/api/serve_image/${id}/${fileName}`
          );
          setImages(imageUrls); // Set the constructed URLs to the state
        }
      } catch (error) {
        console.error('Error fetching images:', error);
        // Handle the error accordingly
      }
    };

    fetchImages();
  }, [id]); // Dependency array includes 'id' to refetch when it changes



  useEffect(() => {
    const fetchSoldHistory = async () => {
      try {
        const response = await api.get(`/vow_homes/home_history?addr=${propertyData["Addr"]}`);
        if (response && response.data) {
          setSoldHistory(response.data);
        }
      } catch (error) {
        console.error('Error fetching sold history:', error);
        // Handle the error accordingly
      }
    };

    if (propertyData) {
      fetchSoldHistory();
    }
  }, [propertyData]);



  const loginButtonOverlay = (
      <div className="login-overlay">
          <button className="login-button" onClick={() => navigate('/login')}>
            Login to see sold history!
          </button>
      </div>
  );

  const soldHistoryContent = (
    <div className={`${!isLoggedIn ? 'blur' : ''}`}>
      <h2>Sold History</h2>
      <table>
        <thead>
          <tr>
            <th>Date Sold</th>
            <th>Selling Price</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {soldHistory.map((history, index) => (
            <tr key={index}>
              <td>{history["Input_date"]}</td>
              <td>${history["Lp_dol"]}</td>
              <td>{history["Lsc"]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );


    const soldHistorySection = (
        <div className={`sold-history`}>
            {soldHistoryContent}
            {!isLoggedIn && loginButtonOverlay}
        </div>
    );



  return (
      <div>
        {images.length > 0 ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
          <div style={{ maxWidth: 800, flexGrow: 1, width: '100%' }}>

            <AutoPlaySwipeableViews
              axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
              index={activeStep}
              onChangeIndex={handleStepChange}
              enableMouseEvents
            >
              {images.map((image, index) => (
                <div key={index}>
                  {Math.abs(activeStep - index) <= 2 ? (
                    <Box
                      component="img"
                      sx={{
                        height: 500,
                        display: 'block',
                        maxWidth: 800,
                        overflow: 'hidden',
                        width: '100%',
                      }}
                      src={image}
                      alt={`Property Image ${index + 1}`}
                    />
                  ) : null}
                </div>
              ))}
            </AutoPlaySwipeableViews>
            <MobileStepper
              steps={images.length}
              position="static"
              activeStep={activeStep}
              nextButton={
                <Button
                  size="small"
                  onClick={handleNext}
                  disabled={activeStep === images.length - 1}
                >
                  Next
                  {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </Button>
              }
              backButton={
                <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                  {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                  Back
                </Button>
              }
            />
          </div>
        </div>
      ) : (
        <div>Loading images...</div>
      )}
          {propertyData ? (
              // Existing JSX code
              <div>
                  <div className="row">
                        <div className="column">
                            <div className="listing-card">
                                <div className="listing-price">${propertyData["Lp_dol"]}</div>
                                <div className="listing-address">{propertyData["Addr"]}</div>
                                <div className="listing-location">{propertyData["Area"]}</div>
                                <div className="listing-mls">MLS® Number: {propertyData["Ml_num"]}</div>
                            </div>
                            <div className="listing-description">
                              <h2>Listing Description</h2>
                              <p>{propertyData["Ad_text"]}</p>
                            </div>
                            <div className="property-summary">
                              <h2>Property Summary</h2>
                              <div className="summary-details">
                                <p>Property Type: {propertyData["Type_own1_out"]}</p>
                                <p>Community Name: {propertyData["Community"]}</p>
                                <p>Parking Type: {propertyData["Gar_type"]}</p>
                              </div>
                            </div>
                            <div className="property-features">
                                <h2>Building</h2>
                                <div className="feature-category">
                                    <h3>Bedrooms</h3>
                                    <p>Total: {propertyData["Br"]}</p>
                                </div>
                                <div className="feature-category">
                                    <h3>Parking</h3>
                                    <p>Parking Type: {propertyData["Gar_type"]}</p>
                                    <p>Parking Type: {propertyData["Gar_type"]}</p>
                                    <p>Total Parking Spaces: {propertyData["Park_spcs"]}</p>
                                </div>
                            </div>
                            {soldHistorySection}
                            <div className="listing-source">
                              <p><b>Listing Source</b>: VOW</p>
                            </div>
                        </div>
                      <div className="column">
                          <div className="brokerage-card">
                            <h2>Listing Courtesy Of:</h2>
                            <p>{propertyData["Rltr"]}</p>
                          </div>
                          <div className="salesperson-card">
                            <div className="salesperson-image">
                              <img src="data:image/jpeg;base64,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" alt="Salesperson" />
                            </div>
                            <div className="salesperson-info">
                              <h2>Arsh Kadakia</h2>
                              <p>Salesperson</p>
                              <div className="contact-info">
                                <p><i className="phone-icon"></i>647-766-9515</p>
                                <p><i className="web-icon"></i>REALTOR® Website</p>
                              </div>
                              <div className="action-buttons">
                                <button className="email-button">Email</button>
                                <button className="book-showing-button">Book showing</button>
                              </div>
                            </div>
                            <div className="social-media">
                              <button className="facebook-button">
                                <i className="facebook-icon"></i>
                              </button>
                            </div>
                          </div>
                          <div className="brokerage-card">
                              <h2>Homelife G1 Realty</h2>
                              <p>Brokerage</p>
                              <p>2260 Bovaird Dr E #202</p>
                              <p>Brampton, ON L6R 3J5</p>
                              <p><i className="phone-icon"></i> 905-239-9222</p>
                          </div>

                      </div>
                  </div>
              </div>
            ) : (
              <div></div>
            )}


      </div>
  );
}

export default ListingPage;